import React from "react";
import CardCinza from "./CardCinza";

export default function OmnifactoryCustos() {
    return (
        <div className="w-full bg-[#040116] py-18">
            <div className="container mx-auto px-4">
                <div className="text-center mb-24">
                    <h2 className="text-2xl md:text-5xl px-4 md:px-0 font-inter-regular text-white leading-9 md:leading-14">
                        <span className="font-inter-bold pb-4">
                            Reduza custos com suporte
                        </span>{" "}
                        <br />e desenvolva com inteligência.
                    </h2>
                </div>

                {/* Logo card for mobile - shown at the end */}
                <div className="block md:hidden mb-3.5">
                    <div className="flex flex-col space-y-3 w-full">
                        <CardCinza className="p-6 relative h-full text-[18px] w-full">
                            <div>
                                <p className="text-white font-inter-semibold mb-4">
                                    Quer reduzir custos de suporte?
                                </p>
                                <p
                                    className="text-[#4B3BDB] font-poppins-medium text-[32px] leading-tight"
                                    style={{
                                        textShadow: "0 0 7.3px #4B3BDB",
                                    }}
                                >
                                    Nós Mostramos Como.
                                </p>
                            </div>
                        </CardCinza>
                        <CardCinza className="p-6 relative h-full text-[18px] w-full">
                            <div>
                                <p className="text-white font-inter-semibold mb-4">
                                    Seu ERP está instável ou subaproveitado?
                                </p>
                                <p
                                    className="text-[#4B3BDB] font-poppins-medium text-[32px] leading-tight"
                                    style={{
                                        textShadow: "0 0 7.3px #4B3BDB",
                                    }}
                                >
                                    Nós
                                    <br />
                                    Assumimos.
                                </p>
                            </div>
                        </CardCinza>
                        <CardCinza className="p-6 w-full h-full text-[18px]">
                            <div>
                                <p className="text-white font-inter-semibold mb-4">
                                    Precisa manter versões legadas com
                                    segurança?
                                </p>
                                <p
                                    className="text-[#4B3BDB] font-poppins-medium text-[32px] leading-tight"
                                    style={{
                                        textShadow: "0 0 7.3px #4B3BDB",
                                    }}
                                >
                                    Nós Garantimos.
                                </p>
                            </div>
                        </CardCinza>
                        <CardCinza className="p-6 w-full h-full text-[18px]">
                            <div>
                                <p className="text-white font-inter-semibold mb-4">
                                    Deseja acelerar entregas com governança e
                                    escalabilidade?
                                </p>
                                <p
                                    className="text-[#4B3BDB] font-poppins-medium text-[32px] leading-tight"
                                    style={{
                                        textShadow: "0 0 7.3px #4B3BDB",
                                    }}
                                >
                                    A OmniFactory Entrega.
                                </p>
                            </div>
                        </CardCinza>
                        <CardCinza className="p-6 relative h-[100px] w-full flex items-center justify-center">
                            <img
                                src="../assets/omnicore_logo.svg"
                                alt="OmniCore Logo"
                                className="h-24 mx-auto"
                            />
                        </CardCinza>
                    </div>
                </div>

                {/* Desktop layout - hidden on mobile */}
                <article className="hidden md:flex flex-row items-start gap-3.5 container mx-auto max-w-5xl">
                    {/* Coluna da esquerda com 3 cards empilhados */}
                    <div className="flex flex-col space-y-3.5 w-1/2">
                        <div className="flex flex-row space-x-3.5">
                            <CardCinza className="p-6 relative h-[240px] text-[18px]">
                                <div>
                                    <p className="text-white font-inter-semibold mb-4">
                                        Quer reduzir custos de suporte?
                                    </p>
                                    <p
                                        className="text-[#4B3BDB] font-poppins-medium text-[32px] leading-tight"
                                        style={{
                                            textShadow: "0 0 7.3px #4B3BDB",
                                        }}
                                    >
                                        Nós
                                        <br />
                                        Mostramos
                                        <br />
                                        Como.
                                    </p>
                                </div>
                            </CardCinza>
                            <CardCinza className="p-6 relative h-[240px] text-[18px]">
                                <div>
                                    <p className="text-white font-inter-semibold mb-4">
                                        Seu ERP está instável ou subaproveitado?
                                    </p>
                                    <p
                                        className="text-[#4B3BDB] font-poppins-medium text-[32px] leading-tight"
                                        style={{
                                            textShadow: "0 0 7.3px #4B3BDB",
                                        }}
                                    >
                                        Nós
                                        <br />
                                        Assumimos.
                                    </p>
                                </div>
                            </CardCinza>
                        </div>
                        <CardCinza className="p-6 relative h-[100px] w-full flex items-center justify-center">
                            <img
                                src="../assets/omnicore_logo.svg"
                                alt="OmniCore Logo"
                                className="h-24 mx-auto"
                            />
                        </CardCinza>
                    </div>

                    {/* Coluna da direita com os segmentos atendidos */}
                    <div className="flex flex-col space-y-3.5 w-1/2">
                        <CardCinza className="p-6 w-full h-[170px] text-[18px]">
                            <div>
                                <p className="text-white font-inter-semibold mb-4">
                                    Precisa manter versões legadas com
                                    segurança?
                                </p>
                                <p
                                    className="text-[#4B3BDB] font-poppins-medium text-[32px] leading-tight"
                                    style={{
                                        textShadow: "0 0 7.3px #4B3BDB",
                                    }}
                                >
                                    Nós Garantimos.
                                </p>
                            </div>
                        </CardCinza>
                        <CardCinza className="p-6 w-full h-[170px] text-[18px]">
                            <div>
                                <p className="text-white font-inter-semibold mb-4">
                                    Deseja acelerar entregas com governança e
                                    escalabilidade?
                                </p>
                                <p
                                    className="text-[#4B3BDB] font-poppins-medium text-[32px] leading-tight"
                                    style={{
                                        textShadow: "0 0 7.3px #4B3BDB",
                                    }}
                                >
                                    A OmniFactory Entrega.
                                </p>
                            </div>
                        </CardCinza>
                    </div>
                </article>
            </div>
        </div>
    );
}
